import { render } from "./YearsChart.vue?vue&type=template&id=5415571c"
import script from "./YearsChart.vue?vue&type=script&lang=js"
export * from "./YearsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__